import { forwardRef } from 'react';
import type { InputNumberRef } from '@rc-component/input-number';
import { NumberInput } from './NumberInput';
import type { NumberInputProps } from './NumberInput';

/**
 * Props {@link QuantityInput}.
 *
 * Inherits semua props {@link NumberInput} kecuali `numberFormat`/`showControls`
 * yang sudah dikunci sesuai spek Quantity.
 */
export type QuantityInputProps = Omit<
  NumberInputProps,
  'numberFormat' | 'showControls'
>;

/**
 * DERIVATIF: Textbox untuk Quantity (jumlah/kuantitas).
 *
 * Spek (mengikuti aturan Pattern Format Angka — Textbox):
 * - Base: {@link NumberInput} (rata kanan, separator id-ID, 0→'', - prefix).
 * - Integer (tanpa desimal).
 * - **Stepper aktif** (panah atas/bawah).
 *
 * Contoh:
 * - 1500   → tampil `1.500`
 * - -1500  → tampil `-1.500`
 * - 0      → tampil `` (kosong)
 *
 * Pemakaian:
 * ```tsx
 * <QuantityInput value={qty} onChange={setQty} min={0} />
 * ```
 *
 * Dokumentasi pattern: `.claude/docs/Booku v2/ui-patterns/textbox-pattern.md`
 */
export const QuantityInput = forwardRef<InputNumberRef, QuantityInputProps>(
  function QuantityInput(props, ref) {
    return (
      <NumberInput
        ref={ref}
        numberFormat="integer"
        showControls
        {...props}
      />
    );
  }
);
